export default {
  white: "#ffffff",
  black: "#000000",
  whoTurnedTheLightsOff: "#2c2d30",
  mrGhost: "#e3e3e3",
}
